let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fEVep")).then(() => parcelRequire('5eLqg'));